(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $7f8bf2a1a0a1fdf1$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"jSFKT":"shopping-list.5861fc84.js","kxKJ3":"symbol-defs.e6efdff2.svg","ei4R3":"amazon1.875cac08.png","c8Zp5":"applebook1.09bf885c.png","jeqkq":"barnesnoble.84820a41.png","2kw6b":"amazon@1x.100eb040.png","5iIId":"amazon@2x.fdf8ae2a.png","1WDfw":"applebook@1x.58f7dd67.png","dD20i":"applebook@2x.1c1863b9.png","E6g71":"barnesnoble@1x.e62c1f9d.png","96m6w":"barnesnoble@2x.84820a41.png","jXFiS":"index.af8d93ba.js","k70Y7":"index.e16b030e.js"}'));

parcelRequire("xpKCW");
parcelRequire("i8Q71");
parcelRequire("k5quo");


parcelRequire("32ZrB");

var $7rQOT = parcelRequire("7rQOT");
var $83c6144c82bb5213$exports = {};


$83c6144c82bb5213$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("ei4R3");


var $53aa3f8e04bc06fa$exports = {};


$53aa3f8e04bc06fa$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("c8Zp5");


var $5ef83e2010e62c0c$exports = {};


$5ef83e2010e62c0c$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("jeqkq");


var $9904ba7acb0b25af$exports = {};


$9904ba7acb0b25af$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("2kw6b");


var $1fa80d4ee6059684$exports = {};


$1fa80d4ee6059684$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("5iIId");


var $b370126d6d586fa2$exports = {};


$b370126d6d586fa2$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("1WDfw");


var $d0180a8f7a75e979$exports = {};


$d0180a8f7a75e979$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("dD20i");


var $d3320299fcd556b7$exports = {};


$d3320299fcd556b7$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("E6g71");


var $a33f5b1415b3ab63$exports = {};


$a33f5b1415b3ab63$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("96m6w");


var $384e0a7de5f0ff33$exports = {};


$384e0a7de5f0ff33$exports = (parcelRequire("aNJCr")).getBundleURL("jSFKT") + (parcelRequire("iE7OH")).resolve("kxKJ3");


const $663b14e15d52bb0f$var$bookList = document.querySelector("#bookList");
const $663b14e15d52bb0f$var$message = document.querySelector("#message");
// Отримуємо дані про книгу за її ідентифікатором
async function $663b14e15d52bb0f$var$getBook(bookId) {
    const BASE_URL = "https://books-backend.p.goit.global/books/";
    const searchUrl = BASE_URL + bookId;
    try {
        const response = await fetch(searchUrl);
        if (!response.ok) throw new Error("Error");
        const data = await response.json();
        return data;
    } catch (err) {
        console.log(err.message);
        return null;
    }
}
// Завантажуємо масив ідентифікаторів книг з локального сховища
function $663b14e15d52bb0f$var$loadBooksFromLocalStorage() {
    const booksFromLocalStorage = JSON.parse(localStorage.getItem("targetBooks")) || [];
    return booksFromLocalStorage;
}
// Оновлюємо відступ заголовку в залежності від того, чи додані книги до списку
function $663b14e15d52bb0f$var$updateMainTitleMargin(isBooksAdded) {
    const mainTitle = document.querySelector(".shopping-list-title");
    if (isBooksAdded) mainTitle.style.marginBottom = "40px";
}
// Відображаємо карточки книг на сторінці
function $663b14e15d52bb0f$var$displayBooksInShoppingList(bookIds) {
    $663b14e15d52bb0f$var$bookList.innerHTML = "";
    (0, $7rQOT.Loading).init();
    if (bookIds.length === 0) {
        $663b14e15d52bb0f$var$message.style.display = "block";
        $663b14e15d52bb0f$var$updateMainTitleMargin(false);
    } else {
        $663b14e15d52bb0f$var$message.style.display = "none";
        bookIds.forEach(async (bookId)=>{
            try {
                const bookData = await $663b14e15d52bb0f$var$getBook(bookId);
                $663b14e15d52bb0f$var$createBookCard(bookData);
            } catch (err) {
                console.log(err.message);
            }
        });
        $663b14e15d52bb0f$var$updateMainTitleMargin(true);
    }
    (0, $7rQOT.Loading).remove();
}
// Створюємо HTML-структуру карточки книги
function $663b14e15d52bb0f$var$createBookCard(book) {
    const storesImgs = [
        {
            name: "Amazon",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($83c6144c82bb5213$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($9904ba7acb0b25af$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($1fa80d4ee6059684$exports)))
            ]
        },
        {
            name: "Apple Books",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($53aa3f8e04bc06fa$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($b370126d6d586fa2$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($d0180a8f7a75e979$exports)))
            ]
        },
        {
            name: "Barnes and Noble",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($5ef83e2010e62c0c$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($d3320299fcd556b7$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($a33f5b1415b3ab63$exports)))
            ]
        }
    ];
    /**шукаю посилання на сторінку магазинів і записую їх в попередній об'єкт */ storesImgs.forEach((i)=>{
        i.link = book.buy_links.find((item)=>item.name == i.name).url;
    });
    const storesListMarkup = storesImgs.map((i, index)=>{
        return `<li class="modal-shops-item">
            <a class="modal-link" href="${i.link}"
               target="_blank" name="${i.name}"
                        rel="noreferrer noopener">
                        <img class="modal-img-shop${index === 0 ? " first-img" : ""}" src="${i.img[0]}" alt="${i.name}" srcset="${i.img[1]} 1x, ${i.img[2]} 2x">
                    </a>
                </li>`;
    }).join("");
    const bookCard = document.createElement("div");
    bookCard.innerHTML = `
<div class="shopping-card">
      <img class="shopping-image" src="${book.book_image}" alt="${book.list_name}" id="${book._id}" width ="100px">
  <div class = "shopping-descr">
      <h2 class="book-card-title title-shop-list">${book.title}</h2>
      <h3 class="shopping-category title-shop-list">${book.list_name}</h3>
      <div class="shopping-description-container">  <p class="shopping-description">${book.description}</p> </div>
      <div class="link-book-shop">
      <span class="shopping-author">${book.author}</span>
          <ul class="list-shops">
                ${storesListMarkup}
            </ul>
            </div>
            </div>
      <button class="delete-button"><svg width="16" height="16" class="shopping-svg">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($384e0a7de5f0ff33$exports))}#icon-trash-03-1-1"></use></button>
    </div>
  `;
    $663b14e15d52bb0f$var$bookList.appendChild(bookCard);
    const deleteButton = bookCard.querySelector(".delete-button");
    deleteButton.addEventListener("click", ()=>{
        $663b14e15d52bb0f$var$removeBookFromLocalStorage(book._id);
        bookCard.remove();
        if ($663b14e15d52bb0f$var$loadBooksFromLocalStorage().length === 0) $663b14e15d52bb0f$var$message.style.display = "block";
    });
}
// Видаляємо ідентифікатор книги зі списку локального сховища
function $663b14e15d52bb0f$var$removeBookFromLocalStorage(bookIdToRemove) {
    (0, $7rQOT.Loading).init();
    const updatedBooks = $663b14e15d52bb0f$var$loadBooksFromLocalStorage().filter((bookId)=>bookId !== bookIdToRemove);
    localStorage.setItem("targetBooks", JSON.stringify(updatedBooks));
    (0, $7rQOT.Loading).remove();
}
// Завантажуємо ідентифікатори книг з локального сховища та відображає їх карточки
const $663b14e15d52bb0f$var$bookIdsFromLocalStorage = $663b14e15d52bb0f$var$loadBooksFromLocalStorage();
$663b14e15d52bb0f$var$displayBooksInShoppingList($663b14e15d52bb0f$var$bookIdsFromLocalStorage);
// Отримуємо всі карточки книг на сторінці
const $663b14e15d52bb0f$var$bookCards = document.querySelectorAll(".book-card");
$663b14e15d52bb0f$var$bookCards.forEach(async (bookCard)=>{
    const bookId = bookCard.querySelector(".shopping-image").id;
    try {
        const bookData = await $663b14e15d52bb0f$var$getBook(bookId);
        if (bookData) $663b14e15d52bb0f$var$createBookCard(bookData, bookCard);
    } catch (err) {
        console.log(err.message);
    }
});



})();
//# sourceMappingURL=shopping-list.5861fc84.js.map
